import React from 'react'
import { Link } from 'react-router-dom'

export default function Connect({isProjectDetail=false}) {
  return (
    <>
    <section className="connect-section">
        <div className="container">
            <div className="row justify-content-center">

                <div className="col-lg-9 col-md-10 wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                    {isProjectDetail ? 
                    <h3 className='heading'>Let’s Connect and Collaborate</h3> :
                    <h4 className='heading'>Let’s Connect and Collaborate</h4>}
                    
                    <p>Let’s connect and collaborate to bring your vision to life with thoughtful designs and meaningful craftsmanship. Together, we can create spaces that inspire, reflect your personality, and truly elevate the way you live and work.</p>

                    <Link to="mailto:info@nativesutra.com" className="default-butn">
                        <span className="text">info@nativesutra.com</span>
                        <div className="icon-container">
                            <div className="icon icon--left">
                                <i className="fa-solid fa-arrow-right"></i>
                            </div>
                            <div className="icon icon--right">
                                <i className="fa-solid fa-arrow-right"></i>
                            </div>
                        </div>
                    </Link>
                    <br/>
                    <Link to="tel:+91 9910965878" className='connect-numb'>+91 99109 65878</Link>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
